import Input from 'antd/es/input/Input';
import TextArea from 'antd/es/input/TextArea';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import LinksButton from 'shared/design-system/components/links-button';

interface Props {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  note: string;
  setNote: React.Dispatch<React.SetStateAction<string>>;
  saveNote: () => void;
}

const NoteRevenueModal: React.FC<Props> = ({ show, setShow, note, setNote, saveNote }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={() => setShow(false)} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{'Insert a note and save'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextArea value={note} onChange={(e) => setNote(e.target.value)} placeholder={'Insert a note'} />
      </Modal.Body>
      <Modal.Footer>
        <LinksButton className="btn btn-links-outline" onClick={() => setShow(false)}>
          {t('common.cancel')}
        </LinksButton>
        <LinksButton className="btn-primary btn-links" onClick={() => saveNote()}>
          Save
        </LinksButton>
      </Modal.Footer>
    </Modal>
  );
};

export default NoteRevenueModal;
